import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import DecimalHelpBlock from "./DecimalHelpBlock";
import Utils from "./Utils";
import ContractFunding from "./ContractFunding";
import UploadsComponent from "./UploadsComponent";

require('moment/locale/el');

export default class ExpenditureDetailsForm extends Component {
    constructor() {
        super();

        this.state = {
            description: "",
            expenditure_date: moment(),
            expenditure_amount_comma: "",
            expenditure_vat_comma: "",
            expenditure_amount_vat_comma: "",
            vat_number: "",
            funding_source: "",
            framework_contract_id: 0,
            kae_id: 0,
            article_amounts: [],
        };

        this.formChange = this.formChange.bind(this);
        this.handleExpenditureDateChange = this.handleExpenditureDateChange.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleVATChange = this.handleVATChange.bind(this);
    }

    componentWillMount() {
        let expenditure = window.expenditure;

        let expenditure_date = moment();
        if (expenditure.expenditure_date_formatted === null)
            expenditure_date = moment();
        else if (expenditure.expenditure_date_formatted === "")
            expenditure_date = null;
        else
            expenditure_date = moment(expenditure.expenditure_date_formatted, "DD/MM/YYYY");

        this.setState({
            description: expenditure.description,
            expenditure_date: expenditure_date,
            expenditure_amount_comma: expenditure.expenditure_amount_comma,
            expenditure_vat_comma: expenditure.expenditure_vat_comma,
            vat_number: expenditure.vat_number,
            expenditure_amount_vat_comma: expenditure.expenditure_amount_vat_comma,
            funding_source: (expenditure.funding_source ? expenditure.funding_source : "kae"),
            framework_contract_id: expenditure.framework_contract_id,
            kae_id: expenditure.kae_id,
            article_amounts: window.article_amounts,
        }, () => {
            if (this.state.expenditure_amount_comma !== undefined && this.state.expenditure_amount_comma !== "") {
                let amount = parseFloat(this.state.expenditure_amount_comma.replace(",", "."));
                this.setState({
                    expenditure_amount_vat_comma: Utils.calculateAmountVATFromAmount(this.state.expenditure_vat_comma, amount)
                });
            }
        });
    }

    formChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleExpenditureDateChange(date) {
        this.setState({
            expenditure_date: date
        });
    }

    handleAmountChange(e) {
        let value = Utils.handleDecimals(e.target.value);
        let amount = parseFloat(e.target.value.replace(",", "."));
        let amount_vat = Utils.calculateAmountVATFromAmount(this.state.expenditure_vat_comma, amount);

        this.setState({
            expenditure_amount_comma: value,
            expenditure_amount_vat_comma: amount_vat,
        });
    }

    handleVATChange(e) {
        let value = Utils.handleDecimals(e.target.value);
        let vat = parseFloat(e.target.value.replace(",", "."));
        let amount_vat = Utils.calculateAmountVATFromVAT(vat, this.state.expenditure_amount_comma);

        this.setState({
            expenditure_vat_comma: value,
            expenditure_amount_vat_comma: amount_vat
        });
    }

    render() {
        return (
            <div>
                <div className="form-group">
                    <label htmlFor="description" className="control-label col-md-4">
                        {window.__js_contracts.expenditure_description}*
                    </label>
                    <div className="col-md-8">
                        <input type="text"
                               id="description"
                               name="description"
                               value={this.state.description}
                               className="form-control"
                               onChange={this.formChange}/>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="expenditure_date_formatted" className="col-md-4 control-label">
                        {window.__js_contracts.expenditure_date}*
                    </label>
                    <div className="col-md-8">
                        <DatePicker className="form-control"
                                    name="expenditure_date_formatted"
                                    id="expenditure_date_formatted"
                                    selected={this.state.expenditure_date}
                                    onChange={this.handleExpenditureDateChange}
                                    dateFormat="DD/MM/YYYY"
                                    locale="el"/>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="amount" className="control-label col-md-4">{window.__js_contracts.expenditure_amount}</label>
                    <div className="col-md-8">
                        <div className="table-responsive">
                            <table className="table table-hover table-striped table-bordered"
                                   style={{marginBottom: 0}}>
                                <thead>
                                <tr>
                                    <th>{window.__js_contracts.amount_without_vat}*</th>
                                    <th>{window.__js_contracts.vat_rate}*</th>
                                    <th>{window.__js_contracts.amount_with_vat}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>
                                        <input type="text"
                                               id="expenditure_amount_comma"
                                               name="expenditure_amount_comma"
                                               value={this.state.expenditure_amount_comma}
                                               className="form-control"
                                               onChange={this.handleAmountChange}/>
                                    </td>
                                    <td>
                                        <input type="text"
                                               id="expenditure_vat_comma"
                                               name="expenditure_vat_comma"
                                               value={this.state.expenditure_vat_comma}
                                               className="form-control"
                                               onChange={this.handleVATChange}/>
                                    </td>
                                    <td>
                                        <input type="text"
                                               disabled={true}
                                               id="expenditure_amount_vat_comma"
                                               name="expenditure_amount_vat_comma"
                                               value={this.state.expenditure_amount_vat_comma}
                                               className="form-control"
                                               onChange={this.formChange}/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <DecimalHelpBlock/>
                    </div>

                    <div className="form-group">
                        <label htmlFor="vat_number" className="control-label col-md-4">
                           {window.__js_dashboard.supplier_vat_number}
                        </label>
                        <div className="col-md-8">
                            <input type="text"
                               id="vat_number"
                               name="vat_number"
                               value={this.state.vat_number}
                               className="form-control"
                               onChange={this.formChange}/>
                        </div>
                    </div>
                </div>

                <ContractFunding isExpenditure={true}
                                 fundingSource={this.state.funding_source}
                                 frameworkContractId={this.state.framework_contract_id}
                                 kaeId={this.state.kae_id}
                                 articleAmounts={this.state.article_amounts}/>

                <UploadsComponent
                    directoryName="expenditures"
                    parentIdField="expenditure_id"
                />
            </div>
        );
    }
}

if (document.getElementById("expenditure-details-form")) {
    let element = document.getElementById("expenditure-details-form");
    ReactDOM.render(<ExpenditureDetailsForm/>, element);
}